import { documentsRequest } from "./documentsRequest";

export default documentsRequest;
